import { connect } from "react-redux";
import {savePayment} from '../../../actions'

import OrdersUserStyled from "./index";
const mapStateToProps = state => {
  return {
    pay: state.pay,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    savePayment: (payment) => dispatch(savePayment(payment)),
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrdersUserStyled);
